import React from 'react';
import { ExtendedFlex } from '../../coreui';

const SecondContainer = (props) => {
  return (
    <ExtendedFlex
      flexDirection="column"
      textAlign="right"
      flex={1}
      display={['none', null, 'block']}
      {...props}
    />
  );
};

export default SecondContainer;
